import BaseExecutor from 'services/sports/default/base-executor';
import BaseValidator from 'services/validations/base-validator';
import {ClassicValidatorBuilder} from 'services/validations/builders/classic-validator-builder';
import LockedGamesValidator from 'services/validations/locked-games-validator';
import Action from 'actions';

export default class UserAdjustmentsValidatorClassicBuilder extends BaseExecutor {
    getInterface() {
        const {
            sportConfig,
            playersData: {games},
        } = Action.getState();

        const validator = new BaseValidator();

        const classicValidatorBuilder = new ClassicValidatorBuilder().getInterface();
        validator.addSubValidators([classicValidatorBuilder]);

        if (sportConfig.isModeLateswap()) {
            const lockedGamesValidator = new LockedGamesValidator();
            lockedGamesValidator.setDependencies({games});
            validator.addSubValidators([lockedGamesValidator]);
        }

        return validator;
    }
}
